export const CALENDAR_START_HOUR = 6;
export const CALENDAR_END_HOUR = 22;

export const calendarHours = Array.from(
  { length: CALENDAR_END_HOUR - CALENDAR_START_HOUR + 1 },
  (_, index) => CALENDAR_START_HOUR + index,
);
